import angular from 'angular';

angular.module('cloudX').directive('cxSearchRelationInPeppolButton', [
  '$q',
  '$http',
  'appUrls',
  '$filter',
  '$translate',
  'flySvc',
  'ModalService',
  'dataCache',
  function($q, $http, appUrls, $filter, $translate, flySvc, ModalService, dataCache) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        relation: '=',
      },
      template: `<div class="margin10T" style="display:flex;flex-wrap:wrap;justify-content: space-between;">
                <a ng-click="!searching && searchRelationInPeppolNetwork();$event.stopPropagation()"
                    ng-disabled="searching"
                    class="btn btn-default btn-xs"
                    title="{{('Search relation on the PEPPOL network'|translate)}}">
                  <i ng-if="!searching" class="fa fa-search-plus"></i>
                  <i ng-if="searching" class="fa fa-spin fa-spinner "></i>
                  <span data-translate="Search relation on the PEPPOL network"></span>
                </a></div>`,
      require: ['^cxRelationFile'],
      link: function($scope, element, attrs, ctrl) {
        var cxRelFile = ctrl[0];

        $scope.searchRelationInPeppolNetwork = function() {
          if ($scope.relation && $scope.relation.id) {
            const relationId = $scope.relation.id;
            $scope.searching = true;
            $http.post(appUrls.api + '/api/relation/SearchRelationInPeppol?id=' + relationId).then(
              function({ data }) {
                $scope.relation.peppolStatus = data.peppolStatus;
                $scope.relation.peppolLastLookupDate = data.peppolLastLookupDate;
                $scope.searching = false;
                if (data.peppolStatus === 1) {
                  flySvc.error('msgRelationNotFoundOnPeppolNetwork');
                } else if (data.peppolStatus === 2) {
                  flySvc.warning('msgRelationFoundOnPeppolNetworkButNoSupportedDocumentFormats');
                } else if (data.peppolStatus === 3) {
                  flySvc.success('msgRelationFoundOnPeppolNetwork');
                }
              },
              function(error) {
                $scope.searching = false;
                flySvc.error(error);
              },
            );
          }
        };
      },
    };
  },
]);
